// extracted by mini-css-extract-plugin
module.exports = {"cursor":"IconSuccess_cursor__37CPT","root":"IconSuccess_root__1n9Ls","fillColor":"IconSuccess_fillColor__1sict"};